import { getMapOptions } from '@/utils/index'

export function getLimitTimeListOptions() {
  return Array(12)
    .fill(1)
    .map((val, index) => {
      const value = `${index + 1}个月`
      return {
        label: value,
        value,
      }
    })
}
/** 状态 1-待完成签约 2-线上预授信 3-已签约 4-已放款 5-已拒绝 6-已取消  */
export const AgriculturaLoanOrderStatusColorMap = new Map([
  [1, 'rgba(247, 152, 28, 1)'],
  [2, 'rgba(25, 145, 235, 1)'],
  [3, 'rgba(0, 195, 120, 1)'],
  [4, 'rgba(0, 0, 0, 0.22)'],
  [5, 'rgba(248, 83, 89, 1)'],
  [6, 'rgba(0, 0, 0, 0.22)'],
])
